module.exports = __webpack_public_path__ + "media/flags/nl-28521800.svg";